<template>
  <div class="wrapper">
    <page-header/>
    <div class="content container">
      <error-banner v-if="error" :message="error"/>
      <div v-if="clientOnboardingInviteStatusCompleted" class="my-auto text-center w-100">
        <img id="WelcomeImage" src="@/assets/Images/welcome-to-our-pack.png" alt="Welcome"/>
      </div>
      <registration-form v-else-if="clientOnboardingInvite"/>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ErrorHelper } from '../../helpers/ErrorHelper'
import { WebApi } from '../../services/WebApi'
import { ClientOnboardingInviteCacheMixin } from '../../mixins/Registration/ClientOnboardingInviteCacheMixin'
import PageHeader from '../Layout/PageHeader.vue'
import PageFooter from '../Layout/PageFooter.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'
import RegistrationForm from './RegistrationForm.vue'

export default {
  name: 'RegistrationPage',
  mixins: [ClientOnboardingInviteCacheMixin],
  data () {
    return {
      error: '',
      sentNotification: false,
      sendingNotification: false
    }
  },
  computed: {
    inviteId () {
      return this.$route.query.id
    },
    clientOnboardingInviteStatusCreated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.status.id === 1 : false
    },
    clientOnboardingInviteStatusCompleted () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.completed : false
    }
  },
  watch: {
    clientOnboardingInviteStatusCreated (value) {
      if (value) {
        this.tryViewClientOnboardingInvite()
      }
    },
    clientOnboardingInviteStatusCompleted (value) {
      if (value) {
        this.trySendNotification()
      }
    },
    allCacheStepsCompleted (value) {
      if (value) {
        this.trySendNotification()
        this.tryFetchClientOnboardingInvite()
      }
    }
  },
  methods: {
    ...mapActions('ClientOnboardingInvites', [
      'viewClientOnboardingInvite'
    ]),
    tryViewClientOnboardingInvite () {
      const self = this
      if (!self.inviteId || !self.clientOnboardingInviteStatusCreated) {
        return
      }
      self.error = ''
      self.viewClientOnboardingInvite(self.inviteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    trySendNotification () {
      const self = this
      if (self.sendingNotification || self.sentNotification) {
        return
      }
      self.sendingNotification = true
      WebApi.post('ClientOnboardingInvite/' + self.inviteId + '/Notification')
        .then(() => { self.sentNotification = true })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.sendingNotification = false })
    }
  },
  components: {
    'error-banner': ErrorBanner,
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'registration-form': RegistrationForm
  }
}
</script>

<style scoped>
#WelcomeImage {
  width: 100%;
  height: auto;
}

@media (min-width: 768px) {
  #WelcomeImage {
    width: 50%;
  }
}
</style>
